import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

// STANDARD UNIT
export const Liters: ConvertableUnit = {
  label: "L",
  toStandardUnit: l => l,
  toThisUnit: l => l
};

export const CubicMeters: ConvertableUnit = {
  label: "m³",
  toStandardUnit: m3 => m3 * 1000,
  toThisUnit: l => l / 1000
};

export const Gallons: ConvertableUnit = {
  label: "gal",
  toStandardUnit: gal => gal * 3.78541,
  toThisUnit: l => l / 3.78541
};

export const CubicFeet: ConvertableUnit = {
  label: "scf",
  toStandardUnit: scf => scf * 28.317,
  toThisUnit: l => l / 28.317
};

export const volumeUnitList = [CubicMeters, Liters, Gallons, CubicFeet];

export const VolumeUnits = {
  CubicMeters,
  Liters,
  Gallons,
  CubicFeet,
  options: buildOptions(volumeUnitList)
};
